import { render, staticRenderFns } from "./projectViewDetail.vue?vue&type=template&id=0816e0e9&scoped=true"
import script from "./projectViewDetail.vue?vue&type=script&lang=js"
export * from "./projectViewDetail.vue?vue&type=script&lang=js"
import style0 from "./projectViewDetail.vue?vue&type=style&index=0&id=0816e0e9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0816e0e9",
  null
  
)

export default component.exports